module.exports = __webpack_public_path__ + "static/img/09@2x.00877070.png";